// Generic image/video viewer. Anything in the theme can open it by
// dispatching flix:lightbox:open with { imageUrl, alt } for a still image or
// { html } for video/external_video embed markup (cloned from a <template>
// rendered server-side, so the embed URL is always built by Shopify's own
// video_tag/external_video_tag filters rather than reconstructed in JS).
class FlixLightbox extends HTMLElement {
  connectedCallback() {
    this._content = this.querySelector('[data-flix-lightbox-content]');
    var backdrop = this.querySelector('[data-flix-lightbox-backdrop]');
    var closeBtn = this.querySelector('[data-flix-lightbox-close]');
    if (backdrop) backdrop.addEventListener('click', () => this.close());
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    // On window, in capture, so nothing listening on document can stop
    // the key before this viewer hears it.
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hidden) this.close();
    }, true);
    document.addEventListener('flix:lightbox:open', (e) => this.open(e.detail || {}));
  }

  open(detail) {
    if (!this._content) return;
    this._content.innerHTML = '';
    if (detail.html) {
      var template = document.createElement('template');
      template.innerHTML = detail.html;
      this._content.appendChild(template.content.cloneNode(true));
    } else if (detail.imageUrl) {
      var img = document.createElement('img');
      img.src = detail.imageUrl;
      img.alt = detail.alt || '';
      this._content.appendChild(img);
    } else {
      return;
    }
    this.hidden = false;
    if (window.flixModalOpen) window.flixModalOpen();
  }

  close() {
    this.hidden = true;
    if (this._content) this._content.innerHTML = '';
    if (window.flixModalClose) window.flixModalClose();
  }
}
customElements.define('flix-lightbox', FlixLightbox);

// Generic, declarative trigger usable anywhere in the theme: any element
// with data-flix-lightbox-trigger="some-id" opens the lightbox with the
// content of <template id="some-id">, set once at module scope (not inside
// the class) so it can never get bound twice under Theme Editor hot-reload.
if (!window._flixLightboxTriggerBound) {
  window._flixLightboxTriggerBound = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-flix-lightbox-trigger]');
    if (!trigger) return;
    e.preventDefault();
    var template = document.getElementById(trigger.dataset.flixLightboxTrigger);
    if (!template) return;
    document.dispatchEvent(new CustomEvent('flix:lightbox:open', { detail: { html: template.innerHTML } }));
  });
}
